import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Input, MenuItem, Select, Stack, TextField, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useState } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import { Close } from '@mui/icons-material';
import axios from 'axios';
import { endpoint } from '../../config';
import CustomizedSnackbars from '../CustomizedSnackBars';
import { useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

export default function VideoModal({ open, setOpen }) {
  const { genres, contentRatings } = useSelector(state => state.filters)

  const [uploadVideoLink, setUploadVideoLink] = useState('')
  const [uploadThumbnailImageLink, setUploadThumbnailImageLink] = useState('')
  const [uploadTitle, setUploadTitle] = useState('')
  const [selectedGenre, setSelectedGenre] = useState('')
  const [selectedContentRating, setSelectedContentRating] = useState('')
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState('')
  const [message, setMessage] = useState('')

  const handleClose = () => setOpen(false);

  const handleGenre = (e) => {
    setSelectedGenre(e.target.value)
  }

  const handleContentRating = (e) => {
    setSelectedContentRating(e.target.value)
  }


  const handleSubmit = async (e) => {
    console.log(selectedDate)
    let newVideo = {
      videoLink: uploadVideoLink,
      title: uploadTitle,
      genre: selectedGenre,
      contentRating: selectedContentRating,
      releaseDate: selectedDate,
      previewImage: uploadThumbnailImageLink
    }

    await axios.post(endpoint, newVideo).then(res => {
      console.log(res)
      setSeverity('success')
      setMessage('Video upload successful')
      setOpenSnackbar(true)
    }).catch(err => {
      console.log(err)
      setSeverity('error')
      setMessage('Video upload failed')
      setOpenSnackbar(true)
    })
    // console.log('upload response')

    handleClose()
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    
    bgcolor: '#fff',
    color: '#000',
    // height: 600,
    maxWidth: '80vw',
  };

  return (
    <div>
      <CustomizedSnackbars open={openSnackbar} setOpen={setOpenSnackbar} severity={severity} message={message} />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Stack justifyContent='space-between' sx={{ height: '95%', }}>
              <Stack direction='row' justifyContent='space-between'>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Upload Video
                </Typography>
                <IconButton aria-label="delete" onClick={handleClose}>
                  <Close />
                </IconButton>
              </Stack>

              <TextField fullWidth helperText='This link will be user to derive the video' label="Video Link" variant="outlined" />

              <TextField fullWidth helperText='This link will be used to preview the thumbnail image' label="Thumbnail Image Link" variant="outlined" />

              <TextField fullWidth helperText='The title will be the representative text for video' label="Title" variant="outlined" />

              <FormControl fullWidth>
                <InputLabel id="genre-select-helper-label">Genre</InputLabel>
                <Select
                  labelId="genre-select-helper-label"
                  id="genre-select-helper"
                  value={selectedGenre}
                  defaultValue=""
                  label="Genre"
                  onChange={handleGenre}
                  fullWidth
                >
                  {
                    genres.map(genre => (
                      <MenuItem value={genre} key={genre}>
                        {genre}
                      </MenuItem>
                    ))
                  }
                </Select>
                <FormHelperText>Genre will help in categorizing your videos</FormHelperText>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="content-rating-select-helper-label">Age</InputLabel>
                <Select
                  labelId="content-rating-select-helper-label"
                  id="content-rating-select-helper"
                  value={selectedContentRating}
                  defaultValue=""
                  label="Age"
                  onChange={handleContentRating}
                  fullWidth
                >
                  {
                    contentRatings.map(contentRating => (
                      <MenuItem value={contentRating} key={contentRating}>
                        {contentRating}
                      </MenuItem>
                    ))
                  }
                </Select>
                <FormHelperText>This will be used to filter videos on age group suitability</FormHelperText>
              </FormControl>

              <TextField
                type='date'
                placeholder='Realsa'
                fullWidth
                helperText='This will be used to sort videos'
                // label="Release date"
                variant="outlined"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />

              <Stack direction='row' margin='1rem 0 0 0'>
                <Button sx={{ margin: '0 10px', background:"#EE1520", color:"#fff" }} variant="contained" id='upload-btn-submit' onClick={handleSubmit}>
                  Submit
                </Button>
                <Button sx={{ margin: '0 10px' }} variant='contained' id='upload-btn-cancel' onClick={handleClose}>
                  Cancel
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
